<div class="right-header-container">
    <div *ngIf="unitSelectedParams === 'wastePer' && selectedType !== 'line' && selectedType !== 'linetosku' && showInGraph.isStock"
        style="text-align: right;color:#004976;font-weight: 600;font-size: 12px;padding:10px;margin-right:20px;margin-top:10px;">
        <em class="fa fa-info-circle"></em> &nbsp;
        Waste % includes Stock Adj. values
    </div>
    <div class="right-header-left">
        <div class="top-part">
            <div class="unit" *ngIf="unitSelectedParams !== 'wastePer'">
                <span>{{'common.unit' | translate}}&nbsp;-&nbsp;</span>
                <span>{{yRange?.label}}&nbsp;</span>
                <span>{{currencyData?.label}}&nbsp;</span>
                <span>(</span>
                <span>{{yRange?.code}}</span>
                <span [innerHTML]="currencyData?.symbolCode"></span>
                <span>)</span>
            </div>
        </div>
    </div>


    <div class="right-header-center">

        <div class="select-view-container" *ngIf="selectedType === 'line' && !removeLine">



        </div>
        <div class="select-view-container" *ngIf="selectedType === 'sku' && !removeLine">



        </div>
    </div>
    <div class="right-header-right" *ngIf="unitSelectedParams !== 'wastePer'">

    </div>

</div>
<div *ngIf="selectedType === 'sku' || selectedType === 'line'" style="margin-bottom:10px;">
    <div style="width:100%" *ngIf="removeLine">
        <mat-tab-group (click)="selectView($event)" (keydown)="selectView($event)" (keypress)="selectView($event)"
            (keyup)="selectView($event)" [(selectedIndex)]="selectedTabIndex" mat-align-tabs="start"
            animationDuration="0ms">

            <mat-tab label="SKU View">
                <div class="view-line-layout-container">

                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    <div style="width:100%" *ngIf="!removeLine">
        <mat-tab-group (selectedTabChange)="selectView($event)" [(selectedIndex)]="selectedTabIndex"
            mat-align-tabs="start" animationDuration="0ms">
            <mat-tab label="Line View">
                <div class="create-line-layout-container">

                </div>
            </mat-tab>
            <mat-tab label="SKU View">
                <div class="view-line-layout-container">

                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    <span *ngIf="selectedType === 'line' && !removeLine"
        style="text-align: left;color:#004976;font-weight: 600;font-size: 12px;padding-left:5px;padding-right:2px;margin-top:2px;position: relative;top: -34px;left: 67%;">
        <em class="fa fa-info-circle"></em> &nbsp;
        Stock Adj. values are not available at this level
    </span>
</div>

<div *ngIf="selectedType === 'linetosku'" style="margin-bottom:10px;">

    <span
        style="text-align: left;color:#004976;font-weight: 600;font-size: 12px;padding-left:5px;padding-right:2px;margin-top:2px;position: relative;left: 67%;">
        <em class="fa fa-info-circle"></em> &nbsp;
        Stock Adj. values are not available at this level
    </span>
</div>
<div class="chart-header">

    <div class="chart-title" [class.chart-title-change]="!showInGraph.total">
        <mat-icon *ngIf="sortType === 'descending' || sortedWith !== 'name'"
            [class.sorted-class]="sortedWith === 'name'" (click)="selectSortOrder('name', 'ascending')"
            (keydown)="selectSortOrder('name', 'ascending')" (keypress)="selectSortOrder('name', 'ascending')"
            (keyup)="selectSortOrder('name', 'ascending')">
            expand_more</mat-icon>
        <mat-icon *ngIf="sortedWith === 'name' && sortType === 'ascending'" [class.sorted-class]="sortedWith === 'name'"
            (click)="selectSortOrder('name', 'descending')" (keydown)="selectSortOrder('name', 'descending')"
            (keypress)="selectSortOrder('name', 'descending')" (keyup)="selectSortOrder('name', 'descending')">
            expand_less</mat-icon>
        <ng-container *ngIf="selectedType === 'cluster'">
            {{'filter_dropdowns.subRegion' | translate | uppercase}}
        </ng-container>
        <ng-container *ngIf="selectedType === 'factory'">
            {{'filter_dropdowns.factory' | translate | uppercase}}
        </ng-container>
        <ng-container *ngIf="selectedType === 'sku'">
            {{'waste_db.sku' | translate | uppercase}}
        </ng-container>
        <ng-container *ngIf="selectedType === 'linetosku'">
            {{'filter_dropdowns.sku' | translate | uppercase}}
        </ng-container>

        <ng-container *ngIf="selectedType === 'line' && !removeLine">
            <mat-radio-group [(ngModel)]="displayLabel">
                <mat-radio-button checked value="lineSAPName">{{'waste_db.sap_name' | translate | uppercase}}
                </mat-radio-button>
                <mat-radio-button value="lineManexName">{{'waste_db.manex_name' | translate | uppercase}}
                </mat-radio-button>
                <mat-radio-button value="lineLocalName">{{'waste_db.local_name' | translate | uppercase}}
                </mat-radio-button>
            </mat-radio-group>
        </ng-container>
    </div>
    <div class="chart-month">
        <mat-icon *ngIf="sortType === 'descending' || sortedWith !== 'chargePercentageValue'"
            [class.sorted-class]="sortedWith === 'chargePercentageValue'"
            (click)="selectSortOrder('chargePercentageValue', 'ascending')"
            (keydown)="selectSortOrder('chargePercentageValue', 'ascending')"
            (keypress)="selectSortOrder('chargePercentageValue', 'ascending')"
            (keyup)="selectSortOrder('chargePercentageValue', 'ascending')">expand_more
        </mat-icon>
        <mat-icon *ngIf="sortedWith === 'chargePercentageValue' && sortType === 'ascending'"
            [class.sorted-class]="sortedWith === 'chargePercentageValue'"
            (click)="selectSortOrder('chargePercentageValue', 'descending')"
            (keydown)="selectSortOrder('chargePercentageValue', 'descending')"
            (keypress)="selectSortOrder('chargePercentageValue', 'descending')"
            (keyup)="selectSortOrder('chargePercentageValue', 'descending')">expand_less
        </mat-icon>
        CHG.({{ currrentFilter | uppercase}})
    </div>
    <div class="chart-total-waste" *ngIf="showInGraph.total">
        <mat-icon *ngIf="sortType === 'descending' || sortedWith !== 'total'"
            [class.sorted-class]="sortedWith === 'total'" (click)="selectSortOrder('total', 'ascending')"
            (keypress)="selectSortOrder('total', 'ascending')" (keyup)="selectSortOrder('total', 'ascending')"
            (keydown)="selectSortOrder('total', 'ascending')">expand_more
        </mat-icon>
        <mat-icon *ngIf="sortedWith === 'total' && sortType === 'ascending'"
            [class.sorted-class]="sortedWith === 'total'" (click)="selectSortOrder('total', 'descending')"
            (keypress)="selectSortOrder('total', 'descending')" (keyup)="selectSortOrder('total', 'descending')"
            (keydown)="selectSortOrder('total', 'descending')">expand_less
        </mat-icon>
        {{ (unitSelectedParams === 'wastePer' ? 'common.wastepercent' : 'common.wastecost') |
        translate | uppercase}}
    </div>
</div>
<div class="chart-details-container">
    <ng-container *ngIf="(plotData && plotData.length > 0 || isLoading); else noWasteData">
        <div class="chart-details-wrapper" (click)="onBarClick(bar)" (keydown)="onBarClick(bar)"
            *ngFor="let bar of plotData; let first = first; let last = last;let i=index;">
            <div class="chart-graph-data" [class.chart-graph-data-change]="!showInGraph.total">
                <div class="chart-graph-content">
                    <div class="hierarchy-top-graph">
                        <div class="bar fh " style="min-width: 0.4%;" [ngClass]="{ first: first, last: last }"
                            [style.width]="((bar?.total*100)/plotData[0].total)+'%'">

                            <div class="bar-inner" [class.nobackground]="unitSelectedParams === 'wastePer'"
                                (mouseenter)="hoveredItem=bar" (mouseleave)="hoveredItem=null" [popover]="popTemplate"
                                [adaptivePosition]="true" container="body" containerClass="wastedashboardbar"
                                triggers="mouseenter:mouseleave" placement="auto" @fillUp>
                                <div class="component fw" *ngFor="let component of bar?.waste;let i=index"
                                    [ngClass]="component?.type" [style.width]="getABSValue(component, bar)">
                                    <div class="component-value fw"></div>
                                </div>
                                <ng-container
                                    *ngIf="showInGraph.isStock && unitSelectedParams !== 'wastePer' && selectedType !== 'line' && selectedType !== 'linetosku'">
                                    <div class="component fw STOCK" [style.width]="getWidth(bar)">
                                        <div class="component-value fw"></div>
                                    </div>
                                </ng-container>
                            </div>

                        </div>

                    </div>
                </div>
                <div class="chart-graph-name">
                    <mat-label>
                        <ng-container *ngIf="selectedType === 'sku' || selectedType === 'linetosku'">{{bar.id}} -
                            {{bar.name}}
                        </ng-container>
                        <ng-container *ngIf="selectedType !== 'sku' && selectedType !== 'linetosku'">
                            {{bar | stackedBarNameFormatter : displayLabel}}
                        </ng-container>
                    </mat-label>
                </div>
            </div>
            <div class="chart-month-data">
                <ng-container *ngIf="bar.chargePercentageValue !== 'noData'; else noData">

                    <span class="no-data-span" *ngIf="bar.chargePercentageValue === null">-</span>

                    <span *ngIf="bar.chargePercentageValue !== null">{{bar.chargePercentageValue | number :
                        '1.2-2'}}%</span>
                    <ng-container
                        *ngIf="bar.chargePercentageValue && bar.chargePercentageValue !== 'noData' && !bar.upArrow; else upward">
                        <mat-icon class="arrow_downward">arrow_downward</mat-icon>
                    </ng-container>
                    <ng-template #upward>
                        <mat-icon *ngIf="bar.chargePercentageValue" class="arrow_upward">arrow_upward</mat-icon>
                    </ng-template>
                </ng-container>
                <ng-template #noData>
                    <span class="no-data-span">-</span>
                </ng-template>
            </div>
            <ng-container *ngIf="unitSelectedParams === 'wastePer'; else costData">
                <div class="chart-waste-data" *ngIf="showInGraph.total">
                    {{bar?.total |
                    localDecimalPipe}}
                </div>
            </ng-container>
            <ng-template #costData>
                <div class="chart-waste-data" *ngIf="showInGraph.total">
                    {{bar?.total | currencyRateFormatter : currencyData?.currencyRate | sbValFormat : yRange |
                    localDecimalPipe}}
                </div>
            </ng-template>

        </div>
    </ng-container>
    <ng-template #noWasteData>
        <div class="no-data fw fh">
            <div class="info-wrapper">
                <div class="smiley">
                </div>
                <div class="bold">
                    <span> {{'waste_db.no_waste' | translate}}</span>
                </div>
                <div class="sub-info">
                    <span> {{'waste_db.no_waste_desc' | translate}}</span>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #popTemplate>
        <div style="margin-left:10px;">
            <span class="label" style="color:#8898A3">
                <ng-container *ngIf="selectedType === 'cluster'">
                    {{'filter_dropdowns.subRegion' | translate}}
                </ng-container>
                <ng-container *ngIf="selectedType === 'factory'">
                    {{'filter_dropdowns.factory' | translate}}
                </ng-container>
                <ng-container *ngIf="selectedType === 'sku'">
                    {{'filter_dropdowns.sku' | translate}}
                </ng-container>
                <ng-container *ngIf="selectedType === 'linetosku'">
                    {{'filter_dropdowns.sku' | translate}}
                </ng-container>
                <ng-container *ngIf="selectedType === 'line'">
                    {{'filter_dropdowns.line' | translate}}
                </ng-container>
            </span> : <ng-container *ngIf="hoveredItem && hoveredItem.type !== 'Line'">
                <span style="color:#004976;font-weight: 500;">{{hoveredItem?.name}}</span>
            </ng-container>
            <ng-container *ngIf="hoveredItem && hoveredItem.type === 'Line'">
                <span style="color:#004976;font-weight: 500;">{{hoveredItem | stackedBarNameFormatter :
                    displayLabel}}</span>
            </ng-container>
        </div>
        <div class="fw fh popup-wrapper popovercontent">


            <div class="custom_component-details-container">

                <div class="custom_component-details">
                    <div class="label">
                        <span>{{'common.total_waste' | translate}}</span>
                    </div>
                    <div class="component-value">
                        <div class="legend"></div>
                        <span class="value">
                            <span class="unit" [innerHTML]="currencyData?.symbolCode"
                                *ngIf="unitSelectedParams !== 'wastePer'"></span>
                            <span id="TotalWaste" *ngIf="unitSelectedParams !== 'wastePer'">
                                {{hoveredItem?.total | currencyRateFormatter: currencyData?.currencyRate |
                                localDecimalPipe}}
                            </span>
                            <span id="TotalWaste" *ngIf="unitSelectedParams === 'wastePer'">
                                {{hoveredItem?.total | localDecimalPipe}}
                            </span>
                            <span class="unit" *ngIf="unitSelectedParams === 'wastePer'">%</span>
                        </span>
                    </div>
                </div>
                <div class="component-details" style="margin-right:5px;"
                    *ngFor="let item of hoveredItem?.waste;let j=index;">
                    <div class="label">
                        <span> {{item?.type}} </span>
                        <span>{{'common.waste' | translate}}</span>
                    </div>
                    <div class="component-value">
                        <div class="legend {{item?.type}}"></div>
                        <span class="value">
                            <span class="unit" [innerHTML]="currencyData?.symbolCode"
                                *ngIf="unitSelectedParams !== 'wastePer'"></span>
                            <span id="{{item?.type}}" *ngIf="unitSelectedParams !== 'wastePer'">
                                {{item?.value | currencyRateFormatter: currencyData?.currencyRate |
                                localDecimalPipe}}
                            </span>
                            <span id="{{item?.type}}" *ngIf="unitSelectedParams === 'wastePer'">
                                {{item?.value | localDecimalPipe}}
                            </span>
                            <span class="unit" *ngIf="unitSelectedParams === 'wastePer'">%</span>
                        </span>

                    </div>
                </div>

                <div class="component-details" style="margin-right:5px;"
                    *ngIf="unitSelectedParams !== 'wastePer' && showInGraph.isStock && isHide('adjRM')">
                    <div class="label">
                        <span> Adj. RM Waste </span>
                    </div>
                    <div class="component-value">
                        <div class="legend stock"></div>
                        <span class="value">
                            <span class="unit" [innerHTML]="currencyData?.symbolCode"
                                *ngIf="unitSelectedParams !== 'wastePer'"></span>
                            <span *ngIf="unitSelectedParams !== 'wastePer'">
                                {{hoveredItem?.adjRMWaste | currencyRateFormatter: currencyData?.currencyRate |
                                localDecimalPipe}}
                            </span>
                            <span *ngIf="unitSelectedParams === 'wastePer'">
                                {{hoveredItem?.adjRMWaste | localDecimalPipe}}
                            </span>
                            <span class="unit" *ngIf="unitSelectedParams === 'wastePer'">%</span>
                        </span>

                    </div>
                </div>
                <div class="component-details" style="margin-right:5px;"
                    *ngIf="unitSelectedParams !== 'wastePer' && showInGraph.isStock && isHide('adjPM')">
                    <div class="label">
                        <span> Adj. PM Waste </span>

                    </div>
                    <div class="component-value">
                        <div class="legend stock"></div>
                        <span class="value">
                            <span class="unit" [innerHTML]="currencyData?.symbolCode"
                                *ngIf="unitSelectedParams !== 'wastePer'"></span>
                            <span>
                                {{hoveredItem?.adjPMWaste | currencyRateFormatter: currencyData?.currencyRate |
                                localDecimalPipe}}
                            </span>
                            <span class="unit" *ngIf="unitSelectedParams === 'wastePer'">%</span>
                        </span>

                    </div>
                </div>
                <div class="component-details" style="margin-right:5px;"
                    *ngIf="unitSelectedParams !== 'wastePer' && showInGraph.isStock && isHide('adjFG',hoveredItem)">
                    <div class="label">
                        <span> Adj. FG Waste </span>
                    </div>
                    <div class="component-value">
                        <div class="legend stock"></div>
                        <span class="value">
                            <span class="unit" [innerHTML]="currencyData?.symbolCode"
                                *ngIf="unitSelectedParams !== 'wastePer'"></span>
                            <span>
                                {{hoveredItem?.adjFGWaste | currencyRateFormatter: currencyData?.currencyRate |
                                localDecimalPipe}}
                            </span>
                            <span class="unit" *ngIf="unitSelectedParams === 'wastePer'">%</span>
                        </span>

                    </div>
                </div>
                <div class="component-details" style="margin-right:5px;"
                    *ngIf="unitSelectedParams !== 'wastePer' && showInGraph.isStock && showInGraph.sfg && isHide('adjSFG', hoveredItem)">
                    <div class="label">
                        <span> Adj. SFG Waste </span>
                    </div>
                    <div class="component-value">
                        <div class="legend stock"></div>
                        <span class="value">
                            <span class="unit" [innerHTML]="currencyData?.symbolCode"
                                *ngIf="unitSelectedParams !== 'wastePer'"></span>
                            <span>
                                {{hoveredItem?.adjSFGWaste | currencyRateFormatter: currencyData?.currencyRate |
                                localDecimalPipe}}
                            </span>
                            <span class="unit" *ngIf="unitSelectedParams === 'wastePer'">%</span>
                        </span>

                    </div>
                </div>
            </div>

        </div>

    </ng-template>
</div>